import 'addsearch-search-ui/dist/addsearch-search-ui.min.css';
import './index.css';

import AddSearchClient from 'addsearch-js-client';
import AddSearchUI from 'addsearch-search-ui';
import * as React from 'react';

import { AddSearchUi } from './AddSearchUi';

export type FilterType = 'tabs' | 'checkbox-group' | 'radio-group' | 'tags' | 'select-list';

export interface Filter {
    readonly labelText?: string;
    readonly type: FilterType;
    readonly options: {
        [key: string]: { readonly label: string; readonly filter?: { readonly category: string } };
    };
}

export interface SortByOption {
    readonly label: string;
    readonly sortBy: string | string[];
    readonly order: string | string[];
}

interface AddSearchUiIntegrationProps {
    readonly publicSiteKey: string;
    readonly primaryColor?: string;
    readonly customFont?: string;
    readonly searchFieldMaxWidthInPixels?: number;
    readonly searchFieldHeaderText?: string;
    readonly searchButtonText?: string;
    readonly searchInputPlaceholderText?: string;
    readonly hasSearchInputAutofocus?: boolean;
    readonly hasSearchAsYouType?: boolean;
    readonly minLengthToShowSearchAsYouTypeResults?: number;
    readonly hasSearchInputFieldIcon?: boolean;
    readonly hasAutocomplete?: boolean;
    readonly hasAiAnswers?: boolean;
    readonly hasAiAnswersHideToggle?: boolean;
    readonly loadMoreResults?: 'button' | 'pagination';
    readonly sortByOptions?: SortByOption[];
    readonly filters?: Filter[];
    readonly hasActiveFilters?: boolean;
}

export const AddSearchUiIntegration: React.FC<AddSearchUiIntegrationProps> = ({
    publicSiteKey,
    primaryColor,
    customFont,
    searchFieldMaxWidthInPixels = 600,
    searchFieldHeaderText,
    searchButtonText,
    searchInputPlaceholderText = 'Keyword...',
    hasSearchInputAutofocus = true,
    hasSearchAsYouType = false,
    minLengthToShowSearchAsYouTypeResults = 3,
    hasSearchInputFieldIcon = true,
    hasAutocomplete = true,
    hasAiAnswers = false,
    hasAiAnswersHideToggle,
    loadMoreResults = 'pagination',
    sortByOptions = [],
    filters = [],
    hasActiveFilters = true
}) => {
    const [addSearchUi, setAddSearchUi] = React.useState<any | null>(null);

    React.useEffect(() => {
        //   AddSearch JS client instance with your PUBLIC SITEKEY
        const addSearchClient = new AddSearchClient(publicSiteKey);

        // addSearchClient.aiAnswers('What is the weather today?', (response) => {
        //     console.log(response);
        // });

        //   Search UI instance
        const addSearchUi = new AddSearchUI(addSearchClient, { hasAiAnswers: true });

        setAddSearchUi(addSearchUi);
    }, []);

    // Dynamically set primary color (when copy pasting from this repository the below becomes unnecessary)
    React.useEffect(() => {
        if (primaryColor) {
            document.documentElement.style.setProperty('--addsearch-primary-color', primaryColor);
        }
    }, [primaryColor]);

    // Dynamically set custom font (when copy pasting from this repository the below becomes unnecessary)
    React.useEffect(() => {
        if (customFont) {
            document.documentElement.style.setProperty(
                '--addsearch-font-family',
                `'${customFont}', sans-serif`
            );
        }
    }, [customFont]);

    return (
        addSearchUi && (
            <AddSearchUi
                addSearchUi={addSearchUi}
                searchFieldMaxWidthInPixels={searchFieldMaxWidthInPixels}
                searchFieldHeaderText={searchFieldHeaderText}
                searchButtonText={searchButtonText}
                searchInputPlaceholderText={searchInputPlaceholderText}
                hasSearchInputAutofocus={hasSearchInputAutofocus}
                hasSearchAsYouType={hasSearchAsYouType}
                minLengthToShowSearchAsYouTypeResults={minLengthToShowSearchAsYouTypeResults}
                hasSearchInputFieldIcon={hasSearchInputFieldIcon}
                hasAutocomplete={hasAutocomplete}
                hasAiAnswers={hasAiAnswers}
                hasAiAnswersHideToggle={hasAiAnswersHideToggle}
                loadMoreResults={loadMoreResults}
                sortByOptions={sortByOptions}
                filters={filters}
                hasActiveFilters={hasActiveFilters}
            />
        )
    );
};
